import { render, staticRenderFns } from "./option_screen.vue?vue&type=template&id=4f6075de&scoped=true"
var script = {}
import style0 from "./option_screen.vue?vue&type=style&index=0&id=4f6075de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6075de",
  null
  
)

export default component.exports